import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { FadeContent } from "../Compartido/EfectesFonts";
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";
import limpiarHtml from "../Compartido/limpiarHtml.js";

// Amb una sola propietat destacada el carrusel quedava amb una targeta
// sola i un gran buit: en lloc d'això es mostra una fitxa ampla amb una
// graella "bento" de les fotos web i les dades principals al costat.
const DestacadoUnico = ({ ruta, propiedad, config, lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const href = "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica;

    const fotosOrigen = (propiedad.fotos_web && propiedad.fotos_web.length) ? propiedad.fotos_web : (propiedad.foto_principal || []);
    // 5 omplen la graella sencera; amb 3 o 4 es fa servir la de 3 (sense forats)
    const numFotos = fotosOrigen.length >= 5 ? 5 : (fotosOrigen.length >= 3 ? 3 : fotosOrigen.length);
    const fotos = fotosOrigen.slice(0, numFotos);
    const fotosRestants = fotosOrigen.length - numFotos;

    const descripcion = propiedad.ladesccorta ? limpiarHtml(propiedad.ladesccorta) : "";

    return (
        <FadeContent blur={true} duration={200} easing="ease-out" initialOpacity={0} className="bhh-unica">
            <div className={"bhh-unica__galeria bhh-unica__galeria--n" + Math.max(numFotos, 1)}>
                {
                    fotos.length != 0
                        ? fotos.map((foto, index) => (
                            <a href={href} className={"bhh-unica__foto" + (index == fotos.length - 1 && fotosRestants > 0 ? " bhh-unica__foto--mes" : "")} key={foto.id ?? index}>
                                <LazyLoadImage effect='blur' threshold={10} src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + foto.nombre} alt={foto.texto_alt ? foto.texto_alt[lang] : ""} title={foto.texto_title ? foto.texto_title[lang] : ""} />
                                {index == fotos.length - 1 && fotosRestants > 0 &&
                                    <span className="bhh-unica__mes">
                                        <span className="bhh-unica__mes-numero">+{fotosRestants}</span>
                                        <span className="bhh-unica__mes-texto">{t("Ver todas las fotos")}</span>
                                    </span>
                                }
                            </a>
                        ))
                        : <a href={href} className="bhh-unica__foto">
                            <LazyLoadImage effect='blur' threshold={10} src="/images/web/bedloop-nofoto.png" alt="" title="" />
                        </a>
                }
            </div>

            <div className="bhh-unica__info">
                <div className="bhh-unica__intro">
                    {propiedad.ciudad && <span className="bhh-unica__ciutat">{propiedad.ciudad}</span>}
                    <h3 className="bhh-unica__titol"><a href={href}>{propiedad.nombre}</a></h3>
                    {descripcion && <div className="bhh-unica__desc" dangerouslySetInnerHTML={{ __html: descripcion }}></div>}
                </div>

                <div className="bhh-unica__accio">
                    <dl className="bhh-unica__dades">
                        <div>
                            <dt><i className="fa-solid fa-bed" style={{ color: config.color_corporativo_web }}></i> {t("Habitaciones")}</dt>
                            <dd>{propiedad.num_habitaciones}</dd>
                        </div>
                        <div>
                            <dt><i className="fa-solid fa-users" style={{ color: config.color_corporativo_web }}></i> {t("Huéspedes")}</dt>
                            <dd>{propiedad.capacidad_maxima}</dd>
                        </div>
                        <div>
                            <dt><i className="fa-solid fa-bath" style={{ color: config.color_corporativo_web }}></i> {t("Baños")}</dt>
                            <dd>{propiedad.num_banyos}</dd>
                        </div>
                        {propiedad.metros_cuadrados > 0 &&
                            <div>
                                <dt><i className="fa-solid fa-ruler-combined" style={{ color: config.color_corporativo_web }}></i> m²</dt>
                                <dd>{propiedad.metros_cuadrados}</dd>
                            </div>
                        }
                    </dl>

                    <a className="bhh-property__cta bhh-unica__cta" href={href}>
                        {
                            propiedad.by_request == 1
                                ? t("Petición")
                                : t("Reservar")
                        }
                        <i className="fa-solid fa-plus"></i>
                    </a>
                </div>
            </div>
        </FadeContent>
    );
};

const ListaDestacados = ({ ruta, destacadas, config, lang, ambDescripcio = false }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    {/* ************* */ }

    return (
        <>
            {destacadas.map((propiedad, index) => {
                const href = "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica;
                return (
                    <div className="destacats-propietat bhh-property" key={index}>
                        <FadeContent blur={true} duration={200} easing="ease-out" initialOpacity={0} className="bhh-property__card">
                            <a href={href} className="bhh-property__media">
                                <span className="bhh-property__badge">{propiedad.ciudad}</span>
                                {
                                    propiedad.foto_principal.length != 0
                                        ? <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                        : <LazyLoadImage effect='blur' threshold={10} className="destacats-imatge-propietat" src="/images/web/bedloop-nofoto.png" alt="" title="" />
                                }
                            </a>
                            <div className="bhh-property__body">
                                <span className="destacats-icones-propietat" style={{ color: "" + config.color_corporativo_web + "" }}>
                                    <i className="fa-solid fa-bed"></i> {propiedad['num_habitaciones']} | <i className="fa-solid fa-users"></i> {propiedad['capacidad_maxima']} | <i className="fa-solid fa-bath"></i> {propiedad['num_banyos']}
                                </span>
                                <h3 className="bhh-property__title"><a href={href}>{propiedad.nombre}</a></h3>
                                {ambDescripcio && propiedad.ladesccorta &&
                                    <div className="bhh-property__desc bhh-property__desc--curta" dangerouslySetInnerHTML={{ __html: limpiarHtml(propiedad.ladesccorta) }}></div>
                                }
                                <a className="bhh-property__cta" href={href}>
                                    {
                                        propiedad.by_request == 1
                                            ? t("Petición")
                                            : t("Reservar")
                                    }
                                    <i className="fa-solid fa-plus"></i>
                                </a>
                            </div>
                        </FadeContent>
                    </div>
                );
            })}
        </>
    );
};

const Destacados = ({ destinos, ruta, destacadas, elementosweb, config, lang }) => {

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bhh-property', destacadas.length);

    // Amb 2-3 propietats el carrusel deixava una o dues targetes arraconades
    // a l'esquerra i un buit a la dreta: a l'escriptori passen a ser una
    // graella centrada de targetes més grans (al mòbil segueix lliscant).
    const pocas = destacadas.length == 2 || destacadas.length == 3;
    // Si no hi ha res a desplaçar (graella sencera a la vista) les fletxes sobren
    const ambFletxes = !(navState.atStart && navState.atEnd);

    return (

        <div className="pt-5 fons potblur bhh-destacados">
            <div className="bhh-section__head">
                <span className="bhh-eyebrow">{t("Nuestra selección")}</span>
                {elementosweb.subtitulo_propiedades && <h2 className="text-center">
                    {elementosweb.subtitulo_propiedades[lang]}
                </h2>}
            </div>

            {destacadas.length == 1 ? (
                <DestacadoUnico
                    ruta={ruta}
                    propiedad={destacadas[0]}
                    config={config}
                    lang={lang}
                />
            ) : (
            <div className={"bhh-destacados__carousel" + (pocas ? " bhh-destacados__carousel--pocas bhh-destacados__carousel--n" + destacadas.length : "")}>
                {ambFletxes && <button
                    type="button"
                    disabled={navState.atStart}
                    onClick={() => scrollByCard(-1)}
                    className="bhh-destacados__prev"
                    aria-label={t("Anterior")}
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </button>}
                <div className="bhh-destacados__track" ref={trackRef}>
                    <ListaDestacados
                        ruta={ruta}
                        destacadas={destacadas}
                        config={config}
                        lang={lang}
                        ambDescripcio={pocas}
                    />
                </div>
                {ambFletxes && <button
                    type="button"
                    disabled={navState.atEnd}
                    onClick={() => scrollByCard(1)}
                    className="bhh-destacados__next"
                    aria-label={t("Siguiente")}
                >
                    <i className="fa-solid fa-arrow-right"></i>
                </button>}
            </div>
            )}
        </div>
    );
};

export default Destacados;
